export { Tag } from './Tag';
export type { TagProps, TagVariant } from './Tag';
